import React, { useState, useEffect, useRef } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { useSetFullBreadcrumbTrail } from '../../context/BreadcrumbContext';
import { FaPen, FaPlus, FaSearch, FaList, FaTruck, FaFileAlt, FaCopy, FaCheck, FaTimes, FaDownload, FaFileExport, FaEllipsisV, FaMoneyBillWave, FaTrash, FaFileInvoiceDollar } from 'react-icons/fa';
import Alert from '../../components/Alert';
import api from '../../services/api';
import moment from 'moment';
import { useLocation, useHistory, Link } from 'react-router-dom';
import { moeda } from '../../util/util';
import { etiquetasValorPainel, simboloMoedaOrcamento, valorPainelNaMoedaOrcamento, valorRemessaExteriorPainel } from './remessaExteriorEstimativaPolicy';
import { detalheMoedasOrcamento } from './moedaFornecedorPolicy';
import { buscarExcelOrcamento, idsExcelAllergan, orcamentoEntraNoExcelAllergan, salvarBlobComoArquivo } from './exportarExcelOrcamentoPolicy';
import { toast } from 'react-toastify';
import '../../css/financeiro-parcela-pagar.css';

export default function PainelOrcamento() {
    const token = localStorage.getItem('token');
    const empresa = localStorage.getItem("empresa");
    const perfil = localStorage.getItem("perfil");
    const usuario = localStorage.getItem("idUsuario");
    const location = useLocation();
    const history = useHistory();
    const setFullTrail = useSetFullBreadcrumbTrail();
    const params = new URLSearchParams(location.search);
    const idEvento = params.get('idEvento');
    const idOrcamento = params.get('idOrcamento');

    useEffect(() => {
        if (!idEvento) {
            history.replace('/evento');
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const [filtro, setFiltro] = useState({
        empresa: empresa,
        evento: idEvento,
        id: idOrcamento
    });
    const [orcamentos, setOrcamentos] = useState([]);
    // D-0152: Allergan escolhe vários orçamentos para um Excel só (id → linha, sobrevive à troca de página).
    const [selecaoExcelAllergan, setSelecaoExcelAllergan] = useState({});
    const [baixandoExcelAllergan, setBaixandoExcelAllergan] = useState(false);
    // orcamentoAcaoId: ID do orçamento alvo de Aprovar/Reprovar/etc. (ações por linha)
    const [orcamentoAcaoId, setOrcamentoAcaoId] = useState(null);
    const [nomeEvento, setNomeEvento] = useState('');
    const [nomeCliente, setNomeCliente] = useState('');
    const [showModalAprovar, setShowModalAprovar] = useState(false);
    const [showModalReprovar, setShowModalReprovar] = useState(false);
    const [showModalAprovarCliente, setShowModalAprovarCliente] = useState(false);
    const [showModalAprovarInternacional, setShowModalAprovarInternacional] = useState(false);
    const [comentarios, setComentarios] = useState('');
    const [showModalHistorico, setShowModalHistorico] = useState(false);
    const [historicoAprovacao, setHistoricoAprovacao] = useState([]);
    const [showModalHistoricoAlteracoes, setShowModalHistoricoAlteracoes] = useState(false);
    const [historicoAlteracoes, setHistoricoAlteracoes] = useState([]);
    const [carregandoHistorico, setCarregandoHistorico] = useState(false);
    const [showActionsModal, setShowActionsModal] = useState(false);
    const [actionsModalData, setActionsModalData] = useState({ orcamento: null, actions: [] });
    const [buscaTexto, setBuscaTexto] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'codigo', direction: 'desc' });
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    // Excel em geração por orçamento: o state pinta o item do menu, o ref barra o
    // duplo clique (o state só atualiza no próximo render).
    const [baixandoExcelIds, setBaixandoExcelIds] = useState({});
    const baixandoExcelRef = useRef(new Set());

    const buscar = () => {
        setFiltro(prev => ({ ...prev, buscando: true }));
        api({
            method: 'get',
            action: '/orcamento',
            token: token,
            params: {
                ...filtro,
                ...{
                    perfil: perfil
                }
            }
        })
            .then(response => {
                setOrcamentos(response.data.data);
                setPage(1);
                setFiltro(prev => ({ ...prev, buscando: false }));
            }).catch(err => {
                //console.log(err)
            })
    };

    const buscarEvento = () => {
        if (idEvento) {
            api({
                method: 'get',
                action: '/evento/' + idEvento,
                token: token
            })
                .then(response => {
                    setNomeEvento(response.data.data.nome);
                    if (response.data.data.cliente) {
                        setNomeCliente(response.data.data.cliente.nome);
                    }
                }).catch(err => {
                    //console.log(err)
                })
        }
    };



    // Todas as ações operam no orçamento da linha clicada (orcamentoAcaoId)
    const aprovarOrcamentos = () => {
        if (!comentarios.trim()) { toast.error('É necessário informar comentários para a aprovação'); return; }
        api({ method: 'post', action: '/orcamento/aprovar', token, data: { orcamentoIds: [orcamentoAcaoId], comentarios } })
            .then(() => { toast.success('Orçamento aprovado!'); setShowModalAprovar(false); setComentarios(''); buscar(); })
            .catch(err => toast.error('Erro ao aprovar: ' + (err.response?.data?.error ?? 'Erro desconhecido')));
    };

    const aprovarCliente = () => {
        api({ method: 'post', action: '/orcamento/aprovarCliente', token, data: { orcamentoIds: [orcamentoAcaoId], comentarios } })
            .then(() => { toast.success('Enviado para o Financeiro!'); setShowModalAprovarCliente(false); setComentarios(''); buscar(); })
            .catch(err => toast.error('Erro: ' + (err.response?.data?.error ?? 'Erro desconhecido')));
    };

    const aprovarOrcamentosInternacional = () => {
        if (!comentarios.trim()) { toast.error('É necessário informar comentários'); return; }
        api({ method: 'post', action: '/orcamento/aprovarInternacional', token, data: { orcamentoIds: [orcamentoAcaoId], comentarios } })
            .then(response => { toast.success(response.data?.message ?? 'Aprovado!'); setShowModalAprovarInternacional(false); setComentarios(''); buscar(); })
            .catch(err => toast.error('Erro: ' + (err.response?.data?.error ?? 'Erro desconhecido')));
    };

    const reprovarOrcamentos = () => {
        if (!comentarios.trim()) { toast.error('É necessário informar comentários para a reprovação'); return; }
        api({ method: 'post', action: '/orcamento/reprovar', token, data: { orcamentoIds: [orcamentoAcaoId], comentarios } })
            .then(() => { toast.success('Orçamento reprovado!'); setShowModalReprovar(false); setComentarios(''); buscar(); })
            .catch(err => toast.error('Erro ao reprovar: ' + (err.response?.data?.error ?? 'Erro desconhecido')));
    };

    // "Baixar Excel" do menu ⋮ (caso 14 do QA 25/09): baixa a planilha do
    // orçamento já salvo, sem abrir nem salvar o orçamento. Mesmo endpoint e
    // corpo do botão de dentro do orçamento; o modelo (Chiesi/AbbVie/Sanofi/
    // Master…) quem escolhe é a API pelo cliente do evento. Antes era um
    // <form target="_blank">: a requisição ia para uma aba nova, dependia de
    // popup liberado e falhava calada.
    const downloadExcelOrcamento = async (row) => {
        const chave = String(row.id);
        if (baixandoExcelRef.current.has(chave)) return;
        baixandoExcelRef.current.add(chave);
        setBaixandoExcelIds(prev => ({ ...prev, [chave]: true }));
        const rotulo = row.codigo ? `#${row.codigo}` : '';
        // Toasts do Excel embaixo à direita: no topo o "Gerando Excel..." cobria o
        // X do drawer de ações. O resultado (sucesso/erro) nasce com id próprio e
        // ANTES de tirar o de carregamento — aparece mesmo que o operador tenha
        // fechado o "Gerando Excel..." no meio da geração.
        const posicao = toast.POSITION.BOTTOM_RIGHT;
        const sufixo = `${chave}-${Date.now()}`;
        const toastId = toast.info(`Gerando Excel do orçamento ${rotulo}...`, {
            toastId: `excel-gerando-${sufixo}`, position: posicao, autoClose: false, closeOnClick: false,
        });
        try {
            const { blob, nomeArquivo } = await buscarExcelOrcamento({
                apiUrl: process.env.REACT_APP_API_URL,
                token: localStorage.getItem('token'),
                orcamentoId: row.id,
            });
            salvarBlobComoArquivo(blob, nomeArquivo);
            toast.success(`Excel do orçamento ${rotulo} baixado.`, { toastId: `excel-ok-${sufixo}`, position: posicao });
        } catch (erro) {
            toast.error('Erro ao baixar o Excel: ' + (erro?.message || 'erro desconhecido'), {
                toastId: `excel-erro-${sufixo}`, position: posicao, autoClose: 8000,
            });
        } finally {
            toast.dismiss(toastId);
            baixandoExcelRef.current.delete(chave);
            setBaixandoExcelIds(prev => {
                const proximo = { ...prev };
                delete proximo[chave];
                return proximo;
            });
        }
    };

    // D-0136: orçamento na Previsão não se exclui (as contas do Financeiro ficariam sem orçamento).
    // Camada 1: consulta o estado antes e mostra o motivo no lugar da confirmação; a API recusa com 422.
    const excluirOrcamento = async (orcamentoId) => {
        try {
            const res = await api({ method: 'get', action: `/orcamento/${orcamentoId}/envioPrevisao`, token });
            const bloqueio = res?.data?.data?.exclusao_bloqueio;
            if (bloqueio) {
                toast.error(bloqueio, { toastId: `excluir-bloqueado-${orcamentoId}`, autoClose: 10000 });
                return;
            }
        } catch (e) { /* sem o estado, segue: a API barra o que não pode */ }
        Alert({
            icon: "error",
            confirmButton: "Cancelar",
            denyButton: <><FaTrash size={16} /> Excluir</>,
            title: "Excluir Orçamento",
            callBack: (result) => {
                if (result.isDenied) {
                    api({ method: 'delete', action: '/orcamento/' + orcamentoId, token })
                        .then(() => buscar())
                        .catch(err => toast.error(err.response?.data?.error ?? 'Erro ao excluir o orçamento.', { autoClose: 10000 }));
                }
            }
        });
    };

    const buscarHistoricoAprovacao = (orcamentoId) => {
        setCarregandoHistorico(true);
        setShowModalHistorico(true);
        setHistoricoAprovacao([]);

        api({
            method: 'get',
            action: '/orcamento/historicoAprovacao/' + orcamentoId,
            token: token
        })
            .then(response => {
                setHistoricoAprovacao(response.data.data);
                setCarregandoHistorico(false);
            })
            .catch(err => {
                setCarregandoHistorico(false);
                toast.error('Erro ao buscar histórico: ' + (err.response?.data?.error ?? 'Erro desconhecido'));
            });
    };

    const buscarHistoricoAlteracoes = (orcamentoId) => {
        setShowModalHistoricoAlteracoes(true);
        setHistoricoAlteracoes([]);
        api({
            method: 'get',
            action: '/orcamento/historico/' + orcamentoId,
            token: token
        })
            .then(response => {
                setHistoricoAlteracoes(response.data.data || []);
            })
            .catch(() => { /* silencioso */ });
    };

    const criarModeloDeOrcamento = (orcamentoId) => {
        window.location.href = `/cadastroOrcamentoModelo?orcamentoId=${orcamentoId}`;
    };

    const clonarOrcamento = async (orcamentoId) => {
        if (!window.confirm('Deseja realmente clonar este orçamento? Será criada uma cópia independente com todos os itens.')) {
            return;
        }

        try {
            toast.info('Clonando orçamento... Por favor aguarde.');

            const response = await api({
                method: 'post',
                action: `/orcamento/clonar/${orcamentoId}`,
                token: token
            });

            if (response.data.status) {
                toast.success(response.data.msg || 'Orçamento clonado com sucesso!');
                const novoOrcamentoId = response.data.data?.id;

                if (novoOrcamentoId) {
                    window.location.href = `/cadastroOrcamento/${novoOrcamentoId}`;
                } else {
                    buscar();
                }
            } else {
                toast.error(response.data.error || 'Erro ao clonar orçamento');
            }
        } catch (error) {
            console.error('Erro ao clonar orçamento:', error);
            toast.error('Erro ao clonar orçamento: ' + (error.response?.data?.error ?? error.message ?? 'Erro desconhecido'));
        }
    };

    const alternarExcelAllergan = (linhas, marcar) => {
        setSelecaoExcelAllergan((atual) => {
            const proximo = { ...atual };
            linhas.forEach((row) => {
                if (marcar) proximo[String(row.id)] = row;
                else delete proximo[String(row.id)];
            });
            return proximo;
        });
    };

    const baixarExcelAllergan = async () => {
        const linhas = Object.values(selecaoExcelAllergan);
        if (linhas.length === 0 || baixandoExcelAllergan) return;
        setBaixandoExcelAllergan(true);
        const posicao = toast.POSITION.BOTTOM_RIGHT;
        const sufixo = `allergan-${Date.now()}`;
        const toastId = toast.info(`Gerando Excel de ${linhas.length} orçamento(s)...`, {
            toastId: `excel-gerando-${sufixo}`, position: posicao, autoClose: false, closeOnClick: false,
        });
        try {
            const { blob, nomeArquivo } = await buscarExcelOrcamento({
                apiUrl: process.env.REACT_APP_API_URL,
                token: localStorage.getItem('token'),
                orcamentoIds: idsExcelAllergan(linhas),
                orcamentoId: linhas[0].id,
            });
            salvarBlobComoArquivo(blob, nomeArquivo);
            toast.success(`Excel de ${linhas.length} orçamento(s) baixado.`, { toastId: `excel-ok-${sufixo}`, position: posicao });
        } catch (erro) {
            toast.error('Erro ao baixar o Excel: ' + (erro?.message || 'erro desconhecido'), {
                toastId: `excel-erro-${sufixo}`, position: posicao, autoClose: 8000,
            });
        } finally {
            toast.dismiss(toastId);
            setBaixandoExcelAllergan(false);
        }
    };

    // Todas as ações ficam no 3 pontinhos — seleção múltipla só para o Excel da Allergan (D-0152)
    const renderActionDropdown = (row) => {
        const actions = [];

        // ── Edição ────────────────────────────────────────────────────────
        if (['admin', 'diretor', 'evento', 'eventos', 'gerenteevento', 'gerenteeventointernacional', 'gerenteeventos'].includes(perfil)) {
            actions.push({ label: 'Alterar', icon: <FaPen size={16} />, to: "/cadastroOrcamento/" + row.id });
        }
        if (['gerenteprojeto', 'gerenteprojetos', 'gerentefinanceiro', 'financeiro', 'financeiro.credito', 'financeiro.adiantamento', 'evento', 'gerenteevento', 'gerenteeventointernacional'].includes(perfil) || usuario === row.operador?.id) {
            actions.push({ label: 'Resumo', icon: <FaFileAlt size={16} />, to: "/resumoOrcamento/" + row.id });
        }

        // ── Aprovações ────────────────────────────────────────────────────
        if (['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro', 'financeiro', 'financeiro.credito', 'financeiro.adiantamento'].includes(perfil)) {
            actions.push({
                label: 'Aprovar',
                icon: <FaCheck size={16} />,
                action: () => { setOrcamentoAcaoId(row.id); setShowActionsModal(false); setShowModalAprovar(true); }
            });
            actions.push({
                label: 'Reprovar',
                icon: <FaTimes size={16} />,
                action: () => { setOrcamentoAcaoId(row.id); setShowActionsModal(false); setShowModalReprovar(true); }
            });
        }

        if (['admin', 'diretor', 'gerenteprojeto', 'backoffice', 'evento', 'gerenteevento', 'gerenteeventointernacional'].includes(perfil)) {
            actions.push({
                label: '📤 Enviar para o Financeiro',
                icon: <FaCheck size={16} />,
                action: () => {
                    history.push(`/enviarParaFinanceiro/${row.id}?evento=${idEvento}`);
                }
            });
            // Desde 27/08/2026 não é mais um modal de confirmação: abre a tela de
            // pré-envio, onde o operador confere o que vai para o Financeiro e
            // informa os destinatários do e-mail de faturamento.
            actions.push({
                label: '🧾 Enviar para Faturamento',
                icon: <FaFileInvoiceDollar size={16} />,
                action: () => {
                    history.push(`/faturamentoEnvio/${row.id}`);
                }
            });
        }

        if (perfil === 'gerenteeventointernacional' && (row.evento?.nacionalidade ?? 'nacional') === 'internacional' && !row.dataAprovacaoInternacional) {
            actions.push({
                label: 'Aprovar (Internacional)',
                icon: <FaCheck size={16} />,
                action: () => { setOrcamentoAcaoId(row.id); setShowActionsModal(false); setShowModalAprovarInternacional(true); }
            });
        }

        // ── Adiantamento ─────────────────────────────────────────────────
        actions.push({
            label: 'Solicitar Adiantamento',
            icon: <FaMoneyBillWave size={16} />,
            action: () => { history.push(`/solicitarAdiantamento/${row.id}?evento=${idEvento}`); }
        });

        // ── Outros ───────────────────────────────────────────────────────
        actions.push({ label: 'Histórico de Aprovações', icon: <FaFileAlt size={16} />, action: () => buscarHistoricoAprovacao(row.id) });
        actions.push({ label: 'Histórico de Alterações', icon: <FaList size={16} />, action: () => buscarHistoricoAlteracoes(row.id) });
        // Comprovantes seguem ocultos; o download do Excel é uma ação segura de
        // leitura do orçamento já persistido.
        // actions.push({
        //     label: 'Comprovantes Pagamentos',
        //     icon: <FaDownload size={16} />,
        //     formButton: true,
        //     method: "post",
        //     action: process.env.REACT_APP_API_URL + "/comprovantesPagamentoOrcamento/" + row.id,
        //     data: { token: localStorage.getItem('token') }
        // });
        actions.push({ label: 'Baixar Excel', icon: <FaFileExport size={16} />, carregandoChave: String(row.id), action: () => downloadExcelOrcamento(row) });
        actions.push({ label: 'Criar Modelo', icon: <FaFileExport size={16} />, action: () => criarModeloDeOrcamento(row.id) });
        actions.push({ label: 'Clonar Orçamento', icon: <FaCopy size={16} />, action: () => clonarOrcamento(row.id) });

        if (['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro'].includes(perfil)) {
            actions.push({ label: 'Excluir', icon: <FaTrash size={16} />, action: () => excluirOrcamento(row.id) });
        }

        return (
            <button
                className="fin-pp__rowbtn"
                type="button"
                onClick={(e) => {
                    e.stopPropagation();
                    setActionsModalData({ orcamento: row, actions: actions });
                    setShowActionsModal(true);
                }}
            >
                <FaEllipsisV size={14} />
            </button>
        );
    };

    const getStatusSortValue = (row) => {
        if (row.dataReprovacao || row.dataReprovacaoDiretor) {
            return 'reprovado';
        }
        if (row.dataAprovacao || row.dataAprovacaoDiretor || row.dataAprovacaoCliente || row.dataAprovacaoInternacional) {
            return 'aprovado';
        }
        return 'pendente';
    };

    const getSortValue = (row, key) => {
        switch (key) {
            case 'codigo':
                return Number(row.codigo || 0);
            case 'titulo':
                return (row.titulo || '').toLowerCase();
            case 'data':
                return row.data ? new Date(row.data).getTime() : 0;
            case 'usuario':
                return (row.operador?.nome || '').toLowerCase();
            case 'valor':
                return valorRemessaExteriorPainel(row).valorBrl ? valorRemessaExteriorPainel(row).valor : Number.NEGATIVE_INFINITY;
            case 'aprovacao':
                return getStatusSortValue(row);
            default:
                return '';
        }
    };

    const toggleSort = (key) => {
        setSortConfig((prev) => ({
            key,
            direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
        }));
    };

    const getSortIndicator = (key) => {
        if (sortConfig.key !== key) {
            return '';
        }
        return sortConfig.direction === 'asc' ? ' ▲' : ' ▼';
    };

    const renderStatusCell = (row) => {
        const blocos = [];

        if (row.dataAprovacao) {
            const tooltipText = row.aprovado_por
                ? `Aprovado (Financeiro) por: ${row.aprovado_por.nome}\nData: ${moment(row.dataAprovacao).format('DD/MM/YYYY HH:mm')}`
                : `Aprovado (Financeiro) em: ${moment(row.dataAprovacao).format('DD/MM/YYYY HH:mm')}`;
            blocos.push(
                <span key="fin-ap" className="fin-pp__minitag is-ok" title={tooltipText}>
                    Financeiro · {moment(row.dataAprovacao).format('DD/MM/YYYY')}
                </span>
            );
        } else if (row.dataReprovacao) {
            const tooltipText = row.reprovado_por
                ? `Reprovado (Financeiro) por: ${row.reprovado_por.nome}\nData: ${moment(row.dataReprovacao).format('DD/MM/YYYY HH:mm')}\nMotivo: ${row.motivoReprovacao}`
                : `Reprovado (Financeiro) em: ${moment(row.dataReprovacao).format('DD/MM/YYYY HH:mm')}\nMotivo: ${row.motivoReprovacao}`;
            blocos.push(
                <span key="fin-rp" className="fin-pp__minitag is-danger" title={tooltipText}>
                    Financeiro · {moment(row.dataReprovacao).format('DD/MM/YYYY')}
                </span>
            );
        }

        if (row.dataAprovacaoDiretor) {
            const tooltipText = row.aprovado_diretor_por
                ? `Aprovado (Diretor) por: ${row.aprovado_diretor_por.nome}\nData: ${moment(row.dataAprovacaoDiretor).format('DD/MM/YYYY HH:mm')}`
                : `Aprovado (Diretor) em: ${moment(row.dataAprovacaoDiretor).format('DD/MM/YYYY HH:mm')}`;
            blocos.push(
                <span key="dir-ap" className="fin-pp__minitag is-ok" title={tooltipText}>
                    Diretor · {moment(row.dataAprovacaoDiretor).format('DD/MM/YYYY')}
                </span>
            );
        } else if (row.dataReprovacaoDiretor) {
            const tooltipText = row.reprovado_diretor_por
                ? `Reprovado (Diretor) por: ${row.reprovado_diretor_por.nome}\nData: ${moment(row.dataReprovacaoDiretor).format('DD/MM/YYYY HH:mm')}\nMotivo: ${row.motivoReprovacaoDiretor}`
                : `Reprovado (Diretor) em: ${moment(row.dataReprovacaoDiretor).format('DD/MM/YYYY HH:mm')}\nMotivo: ${row.motivoReprovacaoDiretor}`;
            blocos.push(
                <span key="dir-rp" className="fin-pp__minitag is-danger" title={tooltipText}>
                    Diretor · {moment(row.dataReprovacaoDiretor).format('DD/MM/YYYY')}
                </span>
            );
        }

        if (row.dataAprovacaoCliente) {
            const tooltipText = row.aprovado_por_cliente
                ? `Aprovado (Cliente) por: ${row.aprovado_por_cliente.nome}\nData: ${moment(row.dataAprovacaoCliente).format('DD/MM/YYYY HH:mm')}`
                : `Aprovado (Cliente) em: ${moment(row.dataAprovacaoCliente).format('DD/MM/YYYY HH:mm')}`;
            blocos.push(
                <span key="cli-ap" className="fin-pp__minitag is-info" title={tooltipText}>
                    Cliente · {moment(row.dataAprovacaoCliente).format('DD/MM/YYYY')}
                </span>
            );
        }

        if ((row.evento?.nacionalidade ?? 'nacional') === 'internacional') {
            if (row.dataAprovacaoInternacional) {
                const tooltipText = row.aprovado_internacional_por
                    ? `Aprovado (Internacional) por: ${row.aprovado_internacional_por.nome}\nData: ${moment(row.dataAprovacaoInternacional).format('DD/MM/YYYY HH:mm')}`
                    : `Aprovado (Internacional) em: ${moment(row.dataAprovacaoInternacional).format('DD/MM/YYYY HH:mm')}`;
                blocos.push(
                    <span key="int-ap" className="fin-pp__minitag is-ok" title={tooltipText}>
                        Internacional · {moment(row.dataAprovacaoInternacional).format('DD/MM/YYYY')}
                    </span>
                );
            } else {
                blocos.push(
                    <span key="int-pend" className="fin-pp__minitag is-warn" title="Orçamento internacional aguardando aprovação do Gerente de Eventos Internacional">
                        Internacional pendente
                    </span>
                );
            }
        }

        if (blocos.length === 0) {
            return <span className="fin-pp__pill is-warn">Pendente</span>;
        }

        return <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>{blocos}</div>;
    };

    useEffect(() => { //onload
        buscarEvento();
        buscar();
    },
        // eslint-disable-next-line
        []);

    // Define o trail completo baseado no contexto real: Evento → Orçamentos
    // Evita resíduo histórico de seções não relacionadas (ex: Fornecedores > Fornecedor > Eventos)
    useEffect(() => {
        if (!nomeEvento) return;
        setFullTrail([
            {
                path: `/evento?idEvento=${idEvento}`,
                label: nomeEvento,
            },
            {
                path: location.pathname + location.search,
                label: 'Orçamentos',
            },
        ]);
    }, [nomeEvento]); // eslint-disable-line react-hooks/exhaustive-deps

    const termoBusca = buscaTexto.trim().toLowerCase();
    const orcamentosFiltrados = (orcamentos || []).filter((row) => {
        if (!termoBusca) {
            return true;
        }

        return [
            row.codigo,
            row.titulo,
            row.operador?.nome,
            row.evento?.nome,
        ].some((valor) => String(valor || '').toLowerCase().includes(termoBusca));
    });

    const orcamentosOrdenados = [...orcamentosFiltrados].sort((a, b) => {
        const valorA = getSortValue(a, sortConfig.key);
        const valorB = getSortValue(b, sortConfig.key);

        if (valorA < valorB) {
            return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (valorA > valorB) {
            return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
    });

    const totalRegistros = orcamentosOrdenados.length;
    const totalPaginas = Math.max(1, Math.ceil(totalRegistros / pageSize));
    const paginaAtual = Math.min(page, totalPaginas);
    const inicio = totalRegistros === 0 ? 0 : (paginaAtual - 1) * pageSize;
    const fim = totalRegistros === 0 ? 0 : Math.min(inicio + pageSize, totalRegistros);
    const orcamentosPaginados = orcamentosOrdenados.slice(inicio, inicio + pageSize);
    const temExcelAllergan = orcamentosOrdenados.some(orcamentoEntraNoExcelAllergan);
    const elegiveisExcelNaPagina = orcamentosPaginados.filter(orcamentoEntraNoExcelAllergan);
    const totalAprovados = (orcamentos || []).filter((row) => getStatusSortValue(row) === 'aprovado').length;
    const totalReprovados = (orcamentos || []).filter((row) => getStatusSortValue(row) === 'reprovado').length;
    const totalPendentes = (orcamentos || []).filter((row) => getStatusSortValue(row) === 'pendente').length;
    const acoesTopo = [
        { to: `/cadastroOrcamento?evento=${idEvento}`, label: 'Novo Orçamento', icon: <FaPlus size={15} />, primary: true, roles: ['admin', 'diretor', 'gerenteprojeto', 'gerenteevento', 'gerenteeventointernacional', 'gerentefinanceiro', 'evento'] },
        // Importar Orçamento do Excel OCULTO (Rafael 06/10): a importação grava direto no banco e pode pôr item
        // num grupo a que ele não pertence (fallback por nome). Volta quando passar pela trava de grupo (pendente).
        // { to: `/importarOrcamento/${idEvento}`, label: 'Importar Orçamento do Excel', icon: <FaUpload size={15} />, roles: ['admin', 'diretor', 'gerenteprojeto', 'gerenteevento', 'gerenteeventointernacional', 'gerentefinanceiro', 'evento'] },
        { to: '/orcamentoModelo', label: 'Modelos de Orçamento', icon: <FaList size={15} />, roles: ['admin', 'diretor', 'gerenteprojeto', 'gerenteevento', 'gerenteeventointernacional', 'gerentefinanceiro', 'evento'] },
        { to: '/servicoOrcamento', label: 'Itens Orçamentários', icon: <FaList size={15} />, roles: ['admin', 'diretor', 'gerenteprojeto', 'gerenteevento', 'gerenteeventointernacional', 'gerentefinanceiro', 'evento'] },
        { to: '/produtoOrcamento', label: 'Produtos', icon: <FaList size={15} />, roles: ['admin', 'diretor', 'gerenteprojeto', 'gerenteevento', 'gerenteeventointernacional', 'gerentefinanceiro'] },
        { to: { pathname: '/fornecedor', state: { tipoCadastro: 'orcamento' } }, label: 'Fornecedores', icon: <FaTruck size={15} />, roles: ['admin', 'diretor', 'gerenteprojeto', 'evento'] },
        { to: '/orcamentoRelatorioPagamento', label: 'Relatório de Pagamentos', icon: <FaFileAlt size={15} />, roles: ['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro', 'financeiro', 'financeiro.credito', 'financeiro.adiantamento'] },
    ].filter((acao) => acao.roles.includes(perfil));



    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Orçamentos</h1>
                        <p className="fin-pp__subtitle">
                            {nomeEvento ? `${nomeEvento}${nomeCliente ? ` · ${nomeCliente}` : ''}` : 'Painel de orçamentos do evento'}
                        </p>
                    </div>
                    <div className="fin-pp__actions">
                        {acoesTopo.map((acao) => (
                            <Link
                                key={typeof acao.to === 'string' ? acao.to : `${acao.label}-${acao.to.pathname}`}
                                to={acao.to}
                                className={`fin-pp__btn fin-pp__btn--pill${acao.primary ? ' fin-pp__btn--primary' : ' fin-pp__btn--sm'}`}
                            >
                                {acao.icon} {acao.label}
                            </Link>
                        ))}
                    </div>
                </div>

                <form
                    className="fin-pp__card fin-pp__search"
                    style={{ padding: '14px 16px', marginBottom: 16 }}
                    onSubmit={(e) => e.preventDefault()}
                >
                    <div className="fin-pp__search-field">
                        <FaSearch className="fin-pp__search-ic" size={16} />
                        <input
                            type="text"
                            className="fin-pp__input"
                            placeholder="Buscar por número, título, evento ou usuário"
                            value={buscaTexto}
                            onChange={(e) => {
                                setBuscaTexto(e.target.value);
                                setPage(1);
                            }}
                        />
                    </div>
                    <button
                        type="button"
                        className="fin-pp__btn fin-pp__btn--tall"
                        onClick={() => {
                            setBuscaTexto('');
                            setPage(1);
                        }}
                        disabled={!buscaTexto.trim()}
                    >
                        Limpar
                    </button>
                </form>

                <div className="fin-pp__statusbar" style={{ marginBottom: 16 }}>
                    <div className="fin-pp__statuschip">
                        <span className="fin-pp__statuschip-dot" />
                        <span className="fin-pp__statuschip-num">{orcamentos.length}</span>
                        <span>Total</span>
                    </div>
                    <div className="fin-pp__statuschip">
                        <span className="fin-pp__statuschip-dot" style={{ background: 'var(--fin-ok)' }} />
                        <span className="fin-pp__statuschip-num">{totalAprovados}</span>
                        <span>Aprovados</span>
                    </div>
                    <div className="fin-pp__statuschip">
                        <span className="fin-pp__statuschip-dot" style={{ background: 'var(--fin-dg)' }} />
                        <span className="fin-pp__statuschip-num">{totalReprovados}</span>
                        <span>Reprovados</span>
                    </div>
                    <div className="fin-pp__statuschip">
                        <span className="fin-pp__statuschip-dot" style={{ background: 'var(--fin-wn)' }} />
                        <span className="fin-pp__statuschip-num">{totalPendentes}</span>
                        <span>Pendentes</span>
                    </div>
                </div>

                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    {Object.keys(selecaoExcelAllergan).length > 0 && (
                        <div className="fin-pp__bulkbar">
                            <span className="fin-pp__bulkbar-count">{Object.keys(selecaoExcelAllergan).length} selecionado(s)</span>
                            <div className="fin-pp__bulkbar-actions">
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm" onClick={() => setSelecaoExcelAllergan({})}>Limpar</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary" disabled={baixandoExcelAllergan} onClick={baixarExcelAllergan}>Baixar Excel dos selecionados</button>
                            </div>
                        </div>
                    )}
                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl" style={{ minWidth: 1180, tableLayout: 'auto' }}>
                            <thead>
                                <tr>
                                    {temExcelAllergan && (
                                        <th className="fin-pp__tbl-check">
                                            <input type="checkbox" className="fin-pp__check" aria-label="Selecionar orçamentos da página para o Excel"
                                                checked={elegiveisExcelNaPagina.length > 0 && elegiveisExcelNaPagina.every((row) => selecaoExcelAllergan[String(row.id)])}
                                                disabled={elegiveisExcelNaPagina.length === 0}
                                                onChange={(e) => alternarExcelAllergan(elegiveisExcelNaPagina, e.target.checked)} />
                                        </th>
                                    )}
                                    <th style={{ width: 64 }}>Ações</th>
                                    <th className="is-sortable" style={{ width: 110, textAlign: 'right' }} onClick={() => toggleSort('codigo')}>Número{getSortIndicator('codigo')}</th>
                                    <th className="is-sortable" onClick={() => toggleSort('titulo')}>Título{getSortIndicator('titulo')}</th>
                                    <th className="is-sortable" style={{ width: 150 }} onClick={() => toggleSort('data')}>Data Orçamento{getSortIndicator('data')}</th>
                                    <th className="is-sortable" style={{ width: 190 }} onClick={() => toggleSort('usuario')}>Usuário{getSortIndicator('usuario')}</th>
                                    <th className="is-sortable" style={{ width: 150, textAlign: 'right' }} onClick={() => toggleSort('valor')}>Valor{getSortIndicator('valor')}</th>
                                    <th className="is-sortable" style={{ width: 340 }} onClick={() => toggleSort('aprovacao')}>Aprovação{getSortIndicator('aprovacao')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(filtro.buscando ?? false) ? (
                                    <tr>
                                        <td colSpan={temExcelAllergan ? 8 : 7} className="fin-pp__empty">Buscando orçamentos...</td>
                                    </tr>
                                ) : orcamentosPaginados.length === 0 ? (
                                    <tr>
                                        <td colSpan={temExcelAllergan ? 8 : 7} className="fin-pp__empty">Nenhum orçamento encontrado.</td>
                                    </tr>
                                ) : (
                                    orcamentosPaginados.map((row) => (
                                        <tr key={row.id}>
                                            {temExcelAllergan && (
                                                <td className="fin-pp__tbl-check">
                                                    <input type="checkbox" className="fin-pp__check" aria-label={`Selecionar o orçamento ${row.codigo ?? ''} para o Excel`}
                                                        checked={Boolean(selecaoExcelAllergan[String(row.id)])}
                                                        disabled={!orcamentoEntraNoExcelAllergan(row)}
                                                        title={orcamentoEntraNoExcelAllergan(row) ? undefined : 'Só orçamento em Real de evento nacional entra neste Excel.'}
                                                        onChange={(e) => alternarExcelAllergan([row], e.target.checked)} />
                                                </td>
                                            )}
                                            <td>{renderActionDropdown(row)}</td>
                                            <td style={{ textAlign: 'right' }} className="fin-pp__cell-strong">{row.codigo ?? ''}</td>
                                            <td>
                                                <div className="fin-pp__cell-strong">{row.titulo || 'Sem título'}</div>
                                                {row.evento?.nome ? <div className="fin-pp__cell-muted">{row.evento.nome}</div> : null}
                                            </td>
                                            <td>{row.data ? moment(row.data).format('DD/MM/YYYY') : '-'}</td>
                                            <td>{row.operador?.nome || '-'}</td>
                                            <td style={{ textAlign: 'right' }} className="fin-pp__cell-strong">
                                                {valorRemessaExteriorPainel(row).valorBrl ? 'R$ ' : `${simboloMoedaOrcamento(valorRemessaExteriorPainel(row).moedaOriginal)} `}{moeda(valorRemessaExteriorPainel(row).valor)}
                                                {(() => {
                                                    // Internacional (27/09): valor na moeda do orçamento + câmbio e as moedas dos fornecedores.
                                                    const det = detalheMoedasOrcamento(row);
                                                    if (det.moedaOrcamento === 'real' && det.fornecedores.length === 0) return null;
                                                    return (
                                                        <small className="fin-pp__cell-muted d-block" data-painel-moedas>
                                                            {det.moedaOrcamento !== 'real' && <>{det.simbolo} {moeda(valorPainelNaMoedaOrcamento(valorRemessaExteriorPainel(row), row))} · câmbio {Number(det.cambio).toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })}</>}
                                                            {det.fornecedores.map((f) => (
                                                                <span key={`${f.moeda}-${f.cambioNegociado}`} className="d-block">fornecedor em {f.simbolo} · câmbio {Number(f.cambioNegociado).toLocaleString('pt-BR', { minimumFractionDigits: 4, maximumFractionDigits: 4 })}</span>
                                                            ))}
                                                        </small>
                                                    );
                                                })()}
                                                {etiquetasValorPainel(valorRemessaExteriorPainel(row), row).map((etiqueta) => (
                                                    <small key={etiqueta.texto} className={`${etiqueta.alerta ? 'text-warning' : 'fin-pp__cell-muted'} d-block`} title={etiqueta.title}>{etiqueta.texto}</small>
                                                ))}
                                            </td>
                                            <td>{renderStatusCell(row)}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="fin-pp__pagination">
                        <div className="fin-pp__pagination-info">
                            {totalRegistros === 0 ? '0 registros' : `${inicio + 1}–${fim} de ${totalRegistros}`}
                        </div>
                        <div className="fin-pp__pagination-ctrls">
                            <select
                                className="fin-pp__select"
                                style={{ height: 34 }}
                                value={pageSize}
                                onChange={(e) => {
                                    setPageSize(Number(e.target.value));
                                    setPage(1);
                                }}
                            >
                                {[10, 20, 50, 100].map((n) => <option key={n} value={n}>{n} / pág.</option>)}
                            </select>
                            <button type="button" className="fin-pp__btn fin-pp__btn--sm" disabled={paginaAtual <= 1} onClick={() => setPage((prev) => Math.max(1, prev - 1))}>Anterior</button>
                            <span className="fin-pp__pagination-info">{paginaAtual} / {totalPaginas}</span>
                            <button type="button" className="fin-pp__btn fin-pp__btn--sm" disabled={paginaAtual >= totalPaginas} onClick={() => setPage((prev) => Math.min(totalPaginas, prev + 1))}>Próxima</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal de Aprovação */}
            {showModalAprovar && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget) { setShowModalAprovar(false); setComentarios(''); } }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic is-ok"><FaCheck size={17} /></span>
                                <h3 className="fin-pp__modal-title">Aprovar Orçamento(s)</h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => { setShowModalAprovar(false); setComentarios(''); }}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                <p>Você está prestes a aprovar <strong>{1}</strong> orçamento(s).</p>
                                <div className="fin-pp__field">
                                    <label htmlFor="comentarios" className="fin-pp__label">Comentários *</label>
                                    <textarea
                                        id="comentarios"
                                        className="fin-pp__input"
                                        style={{ height: 'auto', padding: '10px 14px' }}
                                        rows="4"
                                        value={comentarios}
                                        onChange={(e) => setComentarios(e.target.value)}
                                        placeholder="Descreva os comentários sobre a aprovação..."
                                        required
                                    ></textarea>
                                </div>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn" onClick={() => { setShowModalAprovar(false); setComentarios(''); }}>Cancelar</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--ok" onClick={aprovarOrcamentos} disabled={!comentarios.trim()}><FaCheck size={16} /> Aprovar</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Reprovação */}
            {showModalReprovar && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget) { setShowModalReprovar(false); setComentarios(''); } }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic is-danger"><FaTimes size={17} /></span>
                                <h3 className="fin-pp__modal-title">Reprovar Orçamento(s)</h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => { setShowModalReprovar(false); setComentarios(''); }}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                <p>Você está prestes a reprovar <strong>{1}</strong> orçamento(s).</p>
                                <div className="fin-pp__field">
                                    <label htmlFor="comentarios" className="fin-pp__label">Comentários *</label>
                                    <textarea
                                        id="comentarios"
                                        className="fin-pp__input"
                                        style={{ height: 'auto', padding: '10px 14px' }}
                                        rows="4"
                                        value={comentarios}
                                        onChange={(e) => setComentarios(e.target.value)}
                                        placeholder="Descreva os comentários sobre a reprovação..."
                                        required
                                    ></textarea>
                                </div>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn" onClick={() => { setShowModalReprovar(false); setComentarios(''); }}>Cancelar</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--danger" onClick={reprovarOrcamentos} disabled={!comentarios.trim()}><FaTimes size={16} /> Reprovar</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Aprovação pelo Cliente */}
            {showModalAprovarCliente && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget) { setShowModalAprovarCliente(false); setComentarios(''); } }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic is-ok"><FaCheck size={17} /></span>
                                <h3 className="fin-pp__modal-title">Aprovação pelo Cliente</h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => { setShowModalAprovarCliente(false); setComentarios(''); }}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                <p>Confirma a aprovação pelo cliente dos orçamentos selecionados?</p>
                                <div className="fin-pp__field">
                                    <label htmlFor="comentariosCliente" className="fin-pp__label">Comentários (opcional)</label>
                                    <textarea
                                        id="comentariosCliente"
                                        className="fin-pp__input"
                                        style={{ height: 'auto', padding: '10px 14px' }}
                                        rows="3"
                                        value={comentarios}
                                        onChange={(e) => setComentarios(e.target.value)}
                                        placeholder="Observações sobre a aprovação pelo cliente..."
                                    ></textarea>
                                </div>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn" onClick={() => { setShowModalAprovarCliente(false); setComentarios(''); }}>Cancelar</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--ok" onClick={aprovarCliente}><FaCheck size={16} /> Aprovar pelo Cliente</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Aprovação Internacional */}
            {showModalAprovarInternacional && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget) { setShowModalAprovarInternacional(false); setComentarios(''); } }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic"><FaCheck size={17} /></span>
                                <h3 className="fin-pp__modal-title">Aprovar Orçamento(s) Internacional(is)</h3>
                                <button type="button" className="fin-pp__modal-close" onClick={() => { setShowModalAprovarInternacional(false); setComentarios(''); }}><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                <p>Você está prestes a aprovar como internacional <strong>{1}</strong> orçamento(s). Apenas orçamentos de eventos internacionais serão aprovados. Após a aprovação, as parcelas desses orçamentos passarão a aparecer na tela de parcelas a pagar.</p>
                                <div className="fin-pp__field">
                                    <label htmlFor="comentariosInt" className="fin-pp__label">Comentários *</label>
                                    <textarea
                                        id="comentariosInt"
                                        className="fin-pp__input"
                                        style={{ height: 'auto', padding: '10px 14px' }}
                                        rows="4"
                                        value={comentarios}
                                        onChange={(e) => setComentarios(e.target.value)}
                                        placeholder="Descreva os comentários sobre a aprovação internacional..."
                                        required
                                    ></textarea>
                                </div>
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button type="button" className="fin-pp__btn" onClick={() => { setShowModalAprovarInternacional(false); setComentarios(''); }}>Cancelar</button>
                                <button type="button" className="fin-pp__btn fin-pp__btn--primary" onClick={aprovarOrcamentosInternacional} disabled={!comentarios.trim()}><FaCheck size={16} /> Aprovar (Internacional)</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Histórico */}
            {showModalHistorico && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget) { setShowModalHistorico(false); setHistoricoAprovacao([]); setCarregandoHistorico(false); } }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic"><FaList size={17} /></span>
                                <h3 className="fin-pp__modal-title">Histórico de Aprovações/Reprovações</h3>
                                <button
                                    type="button"
                                    className="fin-pp__modal-close"
                                    onClick={() => {
                                        setShowModalHistorico(false);
                                        setHistoricoAprovacao([]);
                                        setCarregandoHistorico(false);
                                    }}
                                ><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                {carregandoHistorico ? (
                                    <div className="fin-pp__empty">Carregando histórico...</div>
                                ) : historicoAprovacao.length === 0 ? (
                                    <div className="fin-pp__empty">Nenhum histórico encontrado.</div>
                                ) : (
                                    <div style={{ display: 'grid', gap: 12 }}>
                                        {historicoAprovacao.map((item, index) => (
                                            <div key={index} className="fin-pp__card" style={{ padding: 14 }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, alignItems: 'flex-start', marginBottom: 8 }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                                        <span className={`fin-pp__pill ${item.acao === 'aprovacao' ? 'is-ok' : 'is-danger'}`}>
                                                            {item.acao === 'aprovacao' ? <FaCheck size={12} /> : <FaTimes size={12} />} {item.acao === 'aprovacao' ? 'Aprovação' : 'Reprovação'}
                                                        </span>
                                                        <span className="fin-pp__minitag is-info">{item.nivel === 'diretor' ? 'Diretor' : 'Financeiro'}</span>
                                                    </div>
                                                    <span className="fin-pp__cell-muted">{moment(item.data).format('DD/MM/YYYY HH:mm')}</span>
                                                </div>
                                                <div className="fin-pp__cell-muted" style={{ marginBottom: item.comentarios ? 8 : 0 }}>
                                                    Usuário: <span className="fin-pp__cell-strong">{item.usuario?.nome || 'N/A'}</span>
                                                </div>
                                                {item.comentarios ? (
                                                    <div className="fin-pp__cell-muted">
                                                        Comentários: <span style={{ color: 'var(--fin-tx)' }}>{item.comentarios}</span>
                                                    </div>
                                                ) : null}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button
                                    type="button"
                                    className="fin-pp__btn"
                                    onClick={() => {
                                        setShowModalHistorico(false);
                                        setHistoricoAprovacao([]);
                                        setCarregandoHistorico(false);
                                    }}
                                >
                                    Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de Histórico de Alterações */}
            {showModalHistoricoAlteracoes && (
                <div className="modal fade show d-block fin-pp fin-pp__modalbg" onClick={(e) => { if (e.target === e.currentTarget) { setShowModalHistoricoAlteracoes(false); setHistoricoAlteracoes([]); } }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content fin-pp__modal">
                            <div className="fin-pp__modal-head">
                                <span className="fin-pp__modal-head-ic"><FaList size={17} /></span>
                                <h3 className="fin-pp__modal-title">Histórico de Alterações</h3>
                                <button
                                    type="button"
                                    className="fin-pp__modal-close"
                                    onClick={() => {
                                        setShowModalHistoricoAlteracoes(false);
                                        setHistoricoAlteracoes([]);
                                    }}
                                ><FaTimes size={16} /></button>
                            </div>
                            <div className="modal-body">
                                {historicoAlteracoes.length === 0 ? (
                                    <div className="fin-pp__empty">Nenhum histórico encontrado.</div>
                                ) : (
                                    <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                                        <div className="fin-pp__tblwrap">
                                            <table className="fin-pp__tbl" style={{ minWidth: 720, tableLayout: 'auto' }}>
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '180px' }}>Data</th>
                                                    <th style={{ width: '200px' }}>Usuário</th>
                                                    <th>Histórico</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {historicoAlteracoes.map((h, idx) => (
                                                    <tr key={idx}>
                                                        <td>{h.data ? moment(h.data).format('DD/MM/YYYY HH:mm:ss') : ''}</td>
                                                        <td>{h.usuario?.nome || ''}</td>
                                                        <td>{h.historico}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="fin-pp__modal-foot">
                                <button
                                    type="button"
                                    className="fin-pp__btn"
                                    onClick={() => {
                                        setShowModalHistoricoAlteracoes(false);
                                        setHistoricoAlteracoes([]);
                                    }}
                                >
                                    Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Drawer de Ações */}
            {showActionsModal && (
                <div className="fin-pp fin-pp__drawer-backdrop" onClick={() => setShowActionsModal(false)}>
                    <div className="fin-pp__drawer" onClick={(e) => e.stopPropagation()}>
                        <div className="fin-pp__drawer-head">
                            <span className="fin-pp__drawer-head-ic"><FaEllipsisV size={16} /></span>
                            <div style={{ minWidth: 0, flex: 1 }}>
                                <h3 className="fin-pp__drawer-title">Ações do orçamento</h3>
                                {actionsModalData.orcamento && (
                                    <p className="fin-pp__drawer-sub">
                                        Orçamento #{actionsModalData.orcamento?.codigo}
                                        {actionsModalData.orcamento?.evento?.nome ? ' — ' + actionsModalData.orcamento.evento.nome : ''}
                                    </p>
                                )}
                            </div>
                            <button type="button" className="fin-pp__drawer-close" title="Fechar" onClick={() => setShowActionsModal(false)}><FaTimes size={16} /></button>
                        </div>
                        <div className="fin-pp__drawer-body">
                            {(() => {
                                const grupos = [
                                    { titulo: 'Cadastro & Resumo', labels: ['Alterar', 'Resumo', 'Criar Modelo', 'Clonar Orçamento'] },
                                    { titulo: 'Aprovações', labels: ['Aprovar', 'Reprovar', 'Aprovar (Internacional)', '📤 Enviar para o Financeiro', '🧾 Enviar para Faturamento'] },
                                    { titulo: 'Financeiro', labels: ['Solicitar Adiantamento'] },
                                    { titulo: 'Históricos', labels: ['Histórico de Aprovações', 'Histórico de Alterações'] },
                                    { titulo: 'Arquivos & Exportação', labels: ['Comprovantes Pagamentos', 'Baixar Excel'] },
                                    { titulo: 'Administração', labels: ['Excluir'] },
                                ];

                                const renderItem = (action, key) => {
                                    const carregando = !!(action.carregandoChave && baixandoExcelIds[action.carregandoChave]);
                                    const inner = (
                                        <>
                                            <span className="fin-pp__drawer-item-ic">{action.icon}</span>
                                            <span className="fin-pp__drawer-item-label">{carregando ? 'Gerando Excel...' : action.label}</span>
                                        </>
                                    );

                                    if (action.formButton) {
                                        return (
                                            <form
                                                key={key}
                                                method={action.method || "get"}
                                                target="_blank"
                                                action={action.action}
                                                style={{ margin: 0 }}
                                            >
                                                {action.data ? <input type="hidden" name="data" value={JSON.stringify(action.data)} /> : null}
                                                <button type="submit" className="fin-pp__drawer-item" style={{ width: '100%' }}>{inner}</button>
                                            </form>
                                        );
                                    }

                                    if (action.to) {
                                        return (typeof action.to === 'object' && action.to.pathname) ? (
                                            <Link key={key} className="fin-pp__drawer-item" to={action.to.pathname} state={action.to.state} onClick={() => setShowActionsModal(false)}>
                                                {inner}
                                            </Link>
                                        ) : (
                                            <Link key={key} className="fin-pp__drawer-item" to={action.to} onClick={() => setShowActionsModal(false)}>
                                                {inner}
                                            </Link>
                                        );
                                    }

                                    return (
                                        <button key={key} type="button" className="fin-pp__drawer-item" disabled={carregando} aria-busy={carregando || undefined} onClick={(e) => { e.stopPropagation(); if (carregando) return; action.action(); setShowActionsModal(false); }}>
                                            {inner}
                                        </button>
                                    );
                                };

                                const usados = new Set();
                                const secoes = grupos.map((grupo) => {
                                    const itens = actionsModalData.actions.filter((action) => grupo.labels.includes(action.label));
                                    itens.forEach((action) => usados.add(action.label));
                                    return { titulo: grupo.titulo, itens };
                                }).filter((secao) => secao.itens.length > 0);
                                const outras = actionsModalData.actions.filter((action) => !usados.has(action.label));
                                if (outras.length > 0) {
                                    secoes.push({ titulo: 'Outras ações', itens: outras });
                                }

                                return secoes.map((secao, indexSecao) => (
                                    <div key={secao.titulo + indexSecao}>
                                        <div className="fin-pp__drawer-section">{secao.titulo}</div>
                                        {secao.itens.map((action, indexAction) => renderItem(action, `${indexSecao}-${indexAction}`))}
                                    </div>
                                ));
                            })()}
                        </div>
                    </div>
                </div>
            )}



        </ErpTemplate>
    );
}
